import { liveSessionManager } from '@saucelabs/sl-util-axios';

const fetchBrowserOptions = () => (
  liveSessionManager.get('/v1/lsm/browsers')
);

const fetchVirtualDeviceOptions = () => (
  liveSessionManager.get('/v1/lsm/devices')
);

export default {
  fetchBrowserOptions,
  fetchVirtualDeviceOptions,
};
